import { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";

export default function RegistrationSuccessDialog({ onProceed }: { onProceed: () => void }) {
  const titleId = useId();
  const proceedButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    proceedButton.current?.focus();
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return createPortal(
    <div className="registration-success-dialog">
      <section className="registration-success-dialog__window" role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <span className="registration-success-dialog__icon" aria-hidden="true"><CheckCircle2 /></span>
        <small>KITANEGO</small>
        <h2 id={titleId}>Registration successful</h2>
        <p>Your Kitanego account has been successfully registered.</p>
        <button ref={proceedButton} type="button" onClick={onProceed}>Proceed <ArrowRight /></button>
      </section>
    </div>,
    document.body,
  );
}
